// A purchased package's expiry, for the Package Purchases screen. Past expires_at the
// API refuses its credits (package_expired), but nothing changes the purchase's status,
// so "expired" is worked out here from the date.

export const isPackageExpired = (purchase, now = Date.now()) => {
  if (!purchase?.expires_at) return false;
  const expiresAt = new Date(purchase.expires_at).getTime();
  return Number.isFinite(expiresAt) && expiresAt <= now;
};

/** "Oct 3, 2026", or "No expiry" when the package never expires. */
export const formatPackageExpiry = (value) => {
  if (!value) return "No expiry";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

/** "2026-11-30" from a date input → the end of that day, local time, as ISO. */
export const endOfDayIso = (dateInputValue) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(String(dateInputValue || ""))) return null;
  const date = new Date(`${dateInputValue}T23:59:59`);
  return Number.isNaN(date.getTime()) ? null : date.toISOString();
};

/** The date input's starting value: the current expiry if still ahead, else 30 days out. */
export const defaultExpiryInput = (purchase, now = Date.now()) => {
  const current = purchase?.expires_at ? new Date(purchase.expires_at) : null;
  const start = current && current.getTime() > now ? current : new Date(now + 30 * 24 * 60 * 60 * 1000);
  const pad = (n) => String(n).padStart(2, "0");
  return `${start.getFullYear()}-${pad(start.getMonth() + 1)}-${pad(start.getDate())}`;
};
